<template>
  <div>
    <v-row>
      <!-- Título -->
      <v-col cols="6" class="mt-2 manageTitle">
        {{$t('datFormsTitles.comDetail')}}
      </v-col>
      <!-- Botón de crear sobre -->
      <v-col cols="6" class="mt-auto text-right">
        <v-btn v-if="dEditable && !dLoading" class="datPrimaryBtn mr-5" depressed @click="fCanSaveComplaint">{{$t('datBtn.create')}}</v-btn>
        <v-progress-circular v-if="dLoading" rotate="-90" size="30" width="3" indeterminate color="datPrimary" class="mr-5" ></v-progress-circular>
        <v-btn v-if="!dLoading && dManager === 'S'" dark depressed class="datPrimaryBtn mr-2" @click="fOpenManageModal()"> {{$t('btn.manageComplaint')}}</v-btn>
        <v-btn v-if="!dLoading" dark depressed class="datPrimaryBtn mr-2" @click="fGoBack()"> {{$t('btn.backTo')}}</v-btn>
      </v-col>
    </v-row>
    <!-- Info cabecera denuncia -->
    <v-col v-if="dComplaintInfo">
      <eComplaintHeader :pComplaintInfo="dComplaintInfo" />
    </v-col>
      <!-- Info de de la denuncia  -->
      <v-col cols="" class="">
      <v-tabs v-model="dTab" show-arrows centered color="datPrimary" class="detailTabs" slider-color="datPrimary">
        <v-tab>{{$t('datTabTitles.generalData')}}</v-tab>
        <v-tab v-if="dComplaintInfo && dManager === 'S'" >{{$t('datTabTitles.actionPlan')}}</v-tab>
        <v-tab v-if="dComplaintInfo" >{{$t('datTabTitles.comments')}}</v-tab>
        <v-tab v-if="dComplaintInfo" >{{$t('datTabTitles.responsible')}}</v-tab>
        <v-tab v-if="dComplaintInfo" >{{$t('datTabTitles.logs')}}</v-tab>
        <v-tab v-if="dComplaintInfo && dManager === 'S'" >{{$t('datTabTitles.accesses')}}</v-tab>
      </v-tabs>
      <!-- Tab de datos generales -->
      <v-tabs-items v-model="dTab" touchless>
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-col class="px-0">
                <eComplaintGeneralData v-bind="cProp" :pEditable="dEditable" :pComplaintInfo="dComplaintInfo" @updatedData="fGetUpdatedData"></eComplaintGeneralData>
              </v-col>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <!-- Tab de Plan de acción -->
        <v-tab-item v-if="dComplaintInfo && dManager === 'S'">
          <v-card flat>
            <v-card-text>
              <v-col class="px-0">
                <eComplaintPDA v-bind="cProp" :pComplaintInfo="dComplaintInfo"></eComplaintPDA>
              </v-col>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <!-- Tab de comentarios -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-col class="px-0">
                <eComplaintComments v-bind="cProp" :pComplaintInfo="dComplaintInfo"></eComplaintComments>
              </v-col>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <!-- Tab de responsables del canal (art. 8) -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-col class="px-0">
                <eComplaintManagers v-bind="cProp" :pComplaintInfo="dComplaintInfo"></eComplaintManagers>
              </v-col>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <!-- Tab de historial -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-col class="px-0">
                <eComplaintLogs v-bind="cProp" :pComplaintInfo="dComplaintInfo"></eComplaintLogs>
              </v-col>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <!-- Tab de accesos -->
        <v-tab-item v-if="dComplaintInfo && dManager === 'S'">
          <v-card flat>
            <v-card-text>
              <v-col class="px-0">
                <eComplaintAccesses  v-bind="cProp" :pComplaintInfo="dComplaintInfo"></eComplaintAccesses>
              </v-col>
            </v-card-text>
          </v-card>
        </v-tab-item>

      </v-tabs-items>
    </v-col>
    <!-- Modal de búsqueda de denuncia anónima -->
    <datModal v-model="dShowAnonymModal" :pTitle="$t('compDetails.anonymousYn')" :pWidth="900" @reboot="fAnonymInfoModal(false, true)">
      <eAnonymInfoModal :pAnonymInfo="dAnonymInfo" @close="fAnonymInfoModal(false, true)" @info-file="fDownloadInfoFile" />
    </datModal> 
    <!-- Modal gestión de denuncias-->
    <datModal v-model="dShowManageModal" :pWidth="600" :pTitle="$t('btn.manageComplaint')">
      <eComplaintManageModal @close="fCloseManageModal" :pComplaintInfo="dComplaintInfo" />
    </datModal>   
  </div>
</template>

<script>

// Mixins y servicios
import mxCanalDenuncias from '@/mixins/mxCanalDenuncias.vue'
import ServiceEcomplaints from '@/services/srv-eComplaints'
import ServiceEcomplaintsPublic from '@/services/srv-eComplaintsPublic'

// Componentes
import eComplaintAccesses from '@/components/EComplaints/complaintDetail/eComplaintAccesses'
import eComplaintComments from '@/components/EComplaints/complaintDetail/eComplaintComments'
import eComplaintGeneralData from '@/components/EComplaints/complaintDetail/eComplaintGeneralData'
import eComplaintLogs from '@/components/EComplaints/complaintDetail/eComplaintLogs'
import eComplaintManagers from '@/components/EComplaints/complaintDetail/eComplaintManagers'
import eComplaintPDA from '@/components/EComplaints/complaintDetail/eComplaintPDA'
import eComplaintHeader from '@/components/EComplaints/complaintDetail/eComplaintHeader'
import eComplaintManageModal from '@/components/EComplaints/complaintDetail/modals/eComplaintManageModal'
import eAnonymInfoModal from '@/components/EComplaints/complaintDetail/modals/eAnonymInfoModal'
import datModal from '@/components/datModal'

export default {
 
  mixins: [mxCanalDenuncias],

  components: {
    eComplaintAccesses,
    eComplaintComments,
    eComplaintGeneralData,
    eComplaintLogs,
    eComplaintManagers,
    eComplaintPDA,
    eComplaintHeader,
    eComplaintManageModal,
    eAnonymInfoModal,
    datModal
  },

  mounted(){
    this.dEditable = this.pEditable

    // Si la denuncia no es nueva (editable) recuperamos los datos con el id de la denuncia
    // y añadimos el registro de acceso
    if (this.dEditable !== true ){
      this.dComplaintInfo = this.pComplaintInfo
      this.fSetComplaintAccess()
    } 
  },

  props: {
    pEditable:{type: Boolean, default: false }, 
    pComplaintInfo:{type: Object },
    pExcludedFiles:{ type: Array, default: () => [] },
    pMaxFileSize:{ type: Number, default: undefined },
    pMaxUploads:{type: String, default: undefined },
    pShowSnackbar:{type: String, default: 'BOTH'}, // SON PARENT BOTH 
  },

  data () {
    return {
      dEditable: true,
      dTab: null,
      dLoading: false,
      dComplaintInfo: null, // Datos de denuncia recuperada
      dComplaintData: {}, // Datos de denuncia nueva 
      dShowManageModal: false,
      dExternalOrigin: localStorage.getItem("externOrigin"),
      dManager: localStorage.getItem("manager") ? localStorage.getItem("manager") : 'N',
      dShowAnonymModal: false,
      dAnonymInfo: {}
    }
  },

  methods:{
    fGoBack(){
      this.$emit('go-back')
    },

    // Añade un registro de acceso a la denuncia
    fSetComplaintAccess(){
      const payload = {
        complaintId: this.dComplaintInfo.complaintId
      }

      if (this.dExternalOrigin){
        ServiceEcomplaintsPublic.setComplaintAccess(payload).catch(error => {
          this.fSnackbarError(error, this.pShowSnackbar)
        })
      }else{
        ServiceEcomplaints.setComplaintAccess(payload).catch(error => {
          this.fSnackbarError(error, this.pShowSnackbar)
        })
      }
    },
    
    // Alerta con datos del sobre
    fSaveAlert(){
      const alert = {
        text: this.$t('datAlert.saveComplaint'),
        action: this.fSaveComplaint,
        icon: 'mdi-information-outline',
        btnText: this.$t('datBtn.save'),
        btnTextCancel: this.$t('datBtn.cancel'),
        type: 'warning'
      }
      this.$bus.$emit('showAlert', alert)
    },

    // Alerta con datos para la recuperación de la denuncia anónima
    fAnonymInfoModal(value, goBack){
      this.dShowAnonymModal = value
      if(goBack){
        this.fGoBack()
        this.$emit('reload-kpis')
      }
    },    

    // Devuelve error si falta alguno de los datos necesarios para la creación de la denuncia 
    // Si está correcto, lanza aviso de guardado de denuncia (después no se puede modificar)
    fCanSaveComplaint(){

      if(this.dComplaintData.anonymousYn === 'N' 
      && (!this.dComplaintData.userName || this.dComplaintData.userName === null || this.dComplaintData.userName.trim() === '' )
        && (!this.dComplaintData.telephone || this.dComplaintData.telephone === null || this.dComplaintData.telephone.trim() === '' )
        && (!this.dComplaintData.email     || this.dComplaintData.email === null     || this.dComplaintData.email.trim() === '' )){
        this.fSnackbarError(this.$t('datError.noContactInfo'), this.pShowSnackbar)

      } else if(this.dComplaintData.email && this.dComplaintData.email.trim() !== '' && !this.fValidateEmail(this.dComplaintData.email)){
        this.fSnackbarError(this.$t('datError.invalidEmail'), this.pShowSnackbar)

      } else if(this.dComplaintData.anonymousYn === 'S' 
        && ( (!this.dComplaintData.secQuestion || this.dComplaintData.secQuestion === null || this.dComplaintData.secQuestion.trim() === '' )
          || (!this.dComplaintData.secAnswer   || this.dComplaintData.secAnswer === null   || this.dComplaintData.secAnswer.trim() === '' ))){
        this.fSnackbarError(this.$t('datError.noSecurityInfo'), this.pShowSnackbar)

      } else if(this.dComplaintData.title === null || this.dComplaintData.title.trim() === ''){
        this.fSnackbarError(this.$t('datError.noTitle'), this.pShowSnackbar)
      
       } else if(this.dComplaintData.typeId === null || !this.dComplaintData.typeId){
        this.fSnackbarError(this.$t('datError.noComplType'), this.pShowSnackbar)

      } else if(!this.dComplaintData.description || this.dComplaintData.description.trim() === ''){
        this.fSnackbarError(this.$t('datError.noDescription'), this.pShowSnackbar)

      } else if(this.dComplaintData.privacyYn === null || this.dComplaintData.privacyYn === 'N'){
        this.fSnackbarError(this.$t('datError.noPrivacy'), this.pShowSnackbar)
                
      }else{
        this.fSaveAlert()
      }
    }, 
    
    // Valida el formato del mail
    fValidateEmail(valor){
      if (!valor || valor.trim() === '') {
        return true
      }

      // Comprobamos que exista al menos una @
      const aIndex = valor.indexOf('@')
      if (aIndex === -1 || valor.lastIndexOf('@') !== aIndex){
        return false
      } 

      // Se paramos la parte del usuarios y del dominio y comprobamos que no estén vacías
      const userPart = valor.substring(0, aIndex)
      const domainPart = valor.substring(aIndex + 1)
      if (!userPart || !domainPart){
        return false
      } 

      // Comprobamos que en el dominio existe al menos un .
      const dotIndex = domainPart.indexOf('.')
      if (dotIndex === -1 || dotIndex === 0 || dotIndex === domainPart.length - 1){
        return false
      } 

      // Comprobamos si existen caracteres inválidos en la parte del usuario
      const allowedUserChars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789._%+-"
      if (!allowedUserChars.includes(userPart[0]) || !allowedUserChars.includes(userPart[userPart.length - 1])) {
        return false
      }

      // Comprobamos si existen caracteres inválidos en la parte del dominio
      const allowedDomainChars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789.-"
      for (const char of domainPart) {
        if (!allowedDomainChars.includes(char)){
          return false
        } 
      }

      return true
    },
    
    fGetUpdatedData(complaintData){
      this.dComplaintData = complaintData
    },

    // Genera una contraseña alfanumérica para las denuncias anonimas 
    fGetComplaintPassword(){
      const passLength = 15 
      const characters = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
      const randomValues = new Uint8Array(passLength)
      crypto.getRandomValues(randomValues)
    
      return Array.from(randomValues, (val) => characters[val % characters.length]).join('')
    },
 
    // Genera un identificador alfanumérico para las denuncias
    fGetComplaintAuxId(){
      const passLength = 10 
      const characters = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
      const randomValues = new Uint8Array(passLength)
      crypto.getRandomValues(randomValues)
    
      return Array.from(randomValues, (val) => characters[val % characters.length]).join('')
    },
    
    // Guarda la denuncia 
    fSaveComplaint(){
      this.dLoading = true
      let password
      const auxiliarId = this.fGetComplaintAuxId()

      // Parte común del payload
      const payload = {
        auxId: auxiliarId, 
        anonymousYn: this.dComplaintData.anonymousYn,
        email: this.dComplaintData.email,
        typeId: this.dComplaintData.typeId,
        title: this.dComplaintData.title,
        description: this.dComplaintData.description,
        termsYn: this.dComplaintData.termsYn,
        privacyYn: this.dComplaintData.privacyYn,
        files: this.dComplaintData.files
      }
      
      //Partes específicas del payload
      if(this.dComplaintData.anonymousYn === 'S'){
        password = this.fGetComplaintPassword()
        this.dAnonymInfo.password = password
        this.dAnonymInfo.auxId = auxiliarId

        payload.secQuestion = this.dComplaintData.secQuestion
        payload.secAnswer = this.dComplaintData.secAnswer
        payload.password = password
      }else{
        payload.userName = this.dComplaintData.userName
        payload.telephone = this.dComplaintData.telephone
        payload.codEmpl = this.dComplaintData.codEmpl
      }

      if(this.dExternalOrigin){ 
        ServiceEcomplaintsPublic.setComplaint(payload).then(response => {
          if (response.statusCode === '200' && response.result !== 'ko'){
            this.dAnonymInfo.complaintId = response.dataRes
            this.fAnonymInfoModal(true)
          }
        }).catch(error => {
          this.fSnackbarError(error, this.pShowSnackbar)
        }).finally(() => {
          this.dLoading = false
        })

      }else{
        ServiceEcomplaints.setComplaint(payload).then(response => {
          if (response.statusCode === '200' && response.result !== 'ko'){
            if (this.dComplaintData.anonymousYn === 'S') {
              this.dAnonymInfo.complaintId = response.dataRes
              this.fAnonymInfoModal(true)
            } else {
              this.fGoBack()
              this.$emit('reload-kpis')
            }
          }
        }).catch(error => {
          this.fSnackbarError(error, this.pShowSnackbar)
        }).finally(() => {
          this.dLoading = false
        })
      }
    },
    
    // Llama al mixin que recupera info para el fichero pdf
    fDownloadInfoFile(){
      this.fDownloadPdfFile( 'CD_ANONYM_PDF', this.dAnonymInfo.complaintId , this.dAnonymInfo.auxId ) 
    },
 
    // Abre la moda de gestión de estados
    fOpenManageModal(){
      this.dShowManageModal = true
    },

    // Cierra la modal de actualización de estados y actualiza la tabla de denuncias
    fCloseManageModal(reload){
      this.dShowManageModal = false 
      if(reload){
        // Si se ha modificado el estado, actualizamos los datos de la denuncia 
        const payload = {
          complaintId: this.dComplaintInfo.complaintId
        }
        //Recuperamos los datos principales de la denuncia
        if (this.dExternalOrigin){
          ServiceEcomplaintsPublic.getComplaintData(payload).then(response => {
            this.dComplaintInfo = global.structuredClone(response.dataRes[0])
          }).catch(error => {
            this.fSnackbarError(error, this.pShowSnackbar)
          })
        }else{
          ServiceEcomplaints.getComplaintData(payload).then(response => {
            this.dComplaintInfo = global.structuredClone(response.dataRes[0])
          }).catch(error => {
            this.fSnackbarError(error, this.pShowSnackbar)
          })
        }      
      }
    },  

  },

  computed: {
    cProp(){
      return this.$route.query
    }
  }
}
</script>